// extracted from @fastcampus/config#trackers
const envConfigs = {
  dev: {
    www: {
      google: {
        id: 'UA-138245180-1',
        optimize: 'OPT-5DMCTZR',
      },
      facebook: {
        id: '513329212774325',
      },
      amplitude: {
        id: '8844428de1fc67f36ef3e12b7aca1519',
      },
    },
    b2e: {
      google: {
        id: 'UA-175183043-3',
      },
    },
    b2b: {
      google: {
        id: 'UA-182678862-2',
      },
    },
  },
  staging: {
    www: {
      google: {
        id: 'UA-138245180-3',
        optimize: 'OPT-MRG6GTV',
      },
      facebook: {
        id: '1272648416245898',
      },
      amplitude: {
        id: '6e549ec6bccb11d858c97b425353f8d0',
      },
    },
    b2e: {
      google: {
        id: 'UA-175183043-2',
      },
    },
    b2b: {
      google: {
        id: 'UA-182678862-3',
      },
    },
  },
  prod: {
    www: {
      google: {
        id: 'UA-58391551-1',
        conversion: 'AW-929832871',
        optimize: 'OPT-WXM7BNJ',
      },
      facebook: {
        id: '1648117745465194',
      },
      mobon: {
        id: 'fastcampus',
      },
      kakao: {
        id: '8801318905351389393',
      },
      naver: {
        id: 's_49ccad7e4536',
      },
      daum: {
        id: 'n7FLs5fNM_eATdBQCe32Jg00',
      },
      beusable: {
        id: 'b171211e113850u135/1749268c79',
        ba: 'ba/56232e73e4',
      },
      amplitude: {
        id: 'ce2bc8596617623a83aed0dd638c77d4',
      },
    },
    b2e: {
      google: {
        id: 'UA-175183043-1',
      },
    },
    b2b: {
      google: {
        id: 'UA-182678862-4',
      },
    },
  },
};

const defaultConfig = {
  www: {
    google: {
      id: 'UA-138245180-4',
      conversion: 'fake',
      optimize: 'OPT-KBCNQJS',
    },
    gtm: {
      id: 'GTM-NVR4XK',
    },
    facebook: {
      id: '1222424581214735',
    },
    kakao: {
      id: 'fake',
    },
    naver: {
      id: 'fake',
    },
    mobon: {
      id: 'fake',
    },
    daum: {
      id: '',
    },
    beusable: {
      id: 'fake',
      ba: 'fake',
    },
    groobee: {
      id: '97b65d734443446c920aebe3c74b1a67',
    },
    amplitude: {
      id: 'fc452922d540aaf72a412d54915feb18',
    },
  },
  b2e: {
    google: {
      id: 'UA-175183043-3',
    },
  },
  b2b: {
    google: {
      id: 'UA-182678862-2',
    },
  },
  coloso: {},
};

const selectedEvnConfig = envConfigs[process.env.NODE_ENV];

if (selectedEvnConfig) {
  const keys = Object.keys(defaultConfig);
  for (const key of keys) {
    if (selectedEvnConfig[key]) {
      defaultConfig[key] = { ...defaultConfig[key], ...selectedEvnConfig[key] };
    }
  }
}

export default defaultConfig;
